module.exports = __webpack_public_path__ + "img/1f9a5.3a784ca.svg";